import { render, staticRenderFns } from "./PageResultRepositoryView.vue?vue&type=template&id=738a649c&scoped=true&"
import script from "./PageResultRepositoryView.vue?vue&type=script&lang=js&"
export * from "./PageResultRepositoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a649c",
  null
  
)

export default component.exports